<!--计费方案编辑-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">编辑计费方案</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>收费单价不能为空，设备如需免费使用，请将对应项的单价设置为0</div>
    </div>
    <div class="header">
      <div class="left">
        <div class="title">方案名称:</div>
        <div><Input v-model="data.name" style="width: 180px" /></div>
        <div v-if="chargeAccess()" class="title">合作伙伴:</div>
        <div v-if="chargeAccess()">
          <Select v-model="data.agent_id" style="width: 180px">
            <Option v-for="(item, index) in agent" :value="item.id" :key="index">{{
              item.agent_name
            }}</Option>
            <!-- <Option :value="user.id">自营</Option> -->
          </Select>
        </div>
        <Button type="success" style="margin-left: 10px" @click="changeShowModalData">附加费设置</Button>
      </div>
      <div class="right">
        <Button @click="$router.back()" style="margin-right: 10px" >取消</Button>
        <Button type="primary" @click="save" :loading="loading">确定</Button>
      </div>
    </div>
    <table class="table" cellspacing="0" cellpadding="0" border="0">
      <tr>
        <th colspan="5">打印/复印</th>
        <th>扫描</th>
      </tr>
      <tr>
        <td>纸张大小</td>
        <td colspan="2">彩色</td>
        <td colspan="2">黑白</td>
        <td>黑白/彩色</td>
      </tr>
      <tr>
        <td>打印计费按面数进行收费: 元/面</td>
        <td>单面</td>
        <td>双面</td>
        <td>单面</td>
        <td>双面</td>
        <td>单面/双面</td>
      </tr>
      <tr>
        <td>A3</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="1"
            v-model="data.a3_color_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="1"
            v-model="data.a3_color_double"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="1"
            v-model="data.a3_mono_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="1"
            v-model="data.a3_mono_double"
          ></InputNumber>
        </td>
        <td rowspan="5">
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="1"
            v-model="data.scan_single"
          ></InputNumber>
        </td>
      </tr>
      <tr>
        <td>A4</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a4_color_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a4_color_double"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a4_mono_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a4_mono_double"
          ></InputNumber>
        </td>
      </tr>
      <tr>
        <td>A5/明信片</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a5_color_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a5_color_double"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a5_mono_single"
          ></InputNumber>
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.a5_mono_double"
          ></InputNumber>
        </td>
      </tr>
      <tr>
        <td>其他</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.other_color_single"
          />
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.other_color_double"
          />
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.other_mono_single"
          />
        </td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.other_mono_double"
          />
        </td>
      </tr>
      <tr>
        <td>证件</td>
        <td colspan="2">
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.idcard_color"
          />
        </td>
        <!-- <td class="disabled"></td> -->
        <td colspan="2">
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.idcard_mono"
          />
        </td>
        <!-- <td class="disabled"></td> -->
      </tr>
      <tr>
        <td>照片冲印</td>
        <td colspan="2">
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.photo_print"
          />
        </td>
        <td>证件照冲印</td>
        <td colspan="2">
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.idcard_print"
          />
        </td>
      </tr>
      <!-- <tr>
        <td>附加费1</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="1000"
            :min="0"
            :step="0.1"
            v-model="data.special_01"
          />
        </td>
        <td>附加费2</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="100"
            :min="0"
            :step="0.1"
            v-model="data.special_02"
          />
        </td>
        <td>附加费3</td>
        <td>
          <InputNumber
            :active-change="false"
            :precision="2"
            :max="100"
            :min="0"
            :step="0.1"
            v-model="data.special_03"
          />
        </td>
      </tr> -->
    </table>
    <Modal v-model="showModal" width="1000" title="附加费设置" :closable="false">
      <div class="showmodal">
        <div class="modalTips">
          <p class="txt">
            附加费默认未生效，如有需要请联系云知印开通“场景打印”功能，并在下方填写附加费金额才能生效；
          </p>
          <p class="txt">
            附加费用于场景打印时，针对场景产生的“成绩单”“学籍卡”“住院病历”“检查报告”等订单打印增收的附加费用，如某台打印机A4黑白单面标准收费单价：0.5元，附加费1（用于学校成绩单打印）：1元，哪么当用户打印一张A4黑白单面的普通文件为：0.5元，打印一张A4黑白单面的成绩单为：1.5元
          </p>
          <div class="tipsText">
            提示：请与云知印确认各项附加费代表的费用，并填写到后方对应的备注项，方便后期查看
          </div>
        </div>
        <Form class="formBox" :label-width="80" inline>
          <FormItem label="附加费1" class="formItem">
            <InputNumber
              v-model="modalData.special_01"
              :min="0"
              :step="0.1"
              class="num"
               :formatter="value => `${parseFloat(Math.floor(value*100)/100)}`"
            />
          </FormItem>
          <FormItem label="备注" class="formItem">
            <Input type="text" v-model="modalData.note.special_01" />
          </FormItem>

          <FormItem label="附加费2" class="formItem">
            <InputNumber
              v-model="modalData.special_02"
              :min="0"
              :step="0.1"
              class="num"
               :formatter="value => `${parseFloat(Math.floor(value*100)/100)}`"
            />
          </FormItem>
          <FormItem label="备注" class="formItem">
            <Input type="text" v-model="modalData.note.special_02" />
          </FormItem>

          <FormItem label="附加费3" class="formItem">
            <InputNumber
              v-model="modalData.special_03"
              :min="0"
              :step="0.1"
              class="num"
               :formatter="value => `${parseFloat(Math.floor(value*100)/100)}`"
            />
          </FormItem>
          <FormItem label="备注" class="formItem">
            <Input type="text" v-model="modalData.note.special_03" />
          </FormItem>

          <FormItem label="附加费4" class="formItem">
            <InputNumber
              v-model="modalData.special_04"
              :min="0"
              :step="0.1"
              class="num"
               :formatter="value => `${parseFloat(Math.floor(value*100)/100)}`"
            />
          </FormItem>
          <FormItem label="备注" class="formItem">
            <Input type="text" v-model="modalData.note.special_04" />
          </FormItem>

          <FormItem label="附加费5" class="formItem">
            <InputNumber
              v-model="modalData.special_05"
              :min="0"
              :step="0.1"
              class="num"
               :formatter="value => `${parseFloat(Math.floor(value*100)/100)}`"
            />
          </FormItem>
          <FormItem label="备注" class="formItem">
            <Input type="text" v-model="modalData.note.special_05" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button size="default" @click="cancelShowModalData">取消</Button>
        <Button type="primary" size="default" @click="changeModalData">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasOneOf } from '@/libs/tools'
export default {
  data () {
    return {
      showModal: false,
      modalData: {
        special_01: 0,
        special_02: 0,
        special_03: 0,
        special_04: 0,
        special_05: 0,
        note: {
          special_01: '',
          special_02: '',
          special_03: '',
          special_04: '',
          special_05: ''
        }
      },
      data: {
        a3_mono_single: null,
        a3_mono_double: null,
        a3_color_single: null,
        a3_color_double: null,
        a4_mono_single: null,
        a4_mono_double: null,
        a4_color_single: null,
        a4_color_double: null,
        a5_mono_single: null,
        a5_mono_double: null,
        a5_color_single: null,
        a5_color_double: null,
        other_mono_single: null,
        other_mono_double: null,
        other_color_single: null,
        other_color_double: null,
        scan_single: null,
        idcard_color: null,
        idcard_mono: null,
        idcard_print: null,
        photo_print: null,
        special_01: 0,
        special_02: 0,
        special_03: 0,
        special_04: 0,
        special_05: 0,
        note: JSON.stringify({
          special_01: '',
          special_02: '',
          special_03: '',
          special_04: '',
          special_05: ''
        })
        // a3_mono_single: 0.5,
        // a3_mono_double: 1,
        // a3_color_single: 0.5,
        // a3_color_double: 1,
        // a4_mono_single: 0.5,
        // a4_mono_double: 1,
        // a4_color_single: 0.5,
        // a4_color_double: 1,
        // a5_mono_single: 0.5,
        // a5_mono_double: 1,
        // a5_color_single: 0.5,
        // a5_color_double: 1,
        // other_mono_single: 0.5,
        // other_mono_double: 1,
        // other_color_single: 0.5,
        // other_color_double: 1,
        // scan_single: 1,
        // idcard_color: 0.5,
        // idcard_mono: 0.5,
        // idcard_print: 1,
        // photo_print: 1
      },
      loading: false,
      columns: [],
      agent: []
    }
  },
  mounted () {
    if (!this.user.tp) {
      this.getAgentList({ p: 0, l: 1000, is_del: 0 }).then((res) => {
        this.agent = res.data
      })
    }
    if (this.$route.params.id) {
      this.infoCharge({ id: this.$route.params.id }).then((res) => {
        const params = {
          special_01: res[0].special_01,
          special_02: res[0].special_02,
          special_03: res[0].special_03,
          special_04: res[0].special_04,
          special_05: res[0].special_05,
          note: res[0].note ? JSON.parse(res[0].note) : {
            special_01: '',
            special_02: '',
            special_03: '',
            special_04: '',
            special_05: ''
          }
        }
        this.modalData = params
        if (!res[0].note) {
          res[0].note = JSON.stringify({
            special_01: '',
            special_02: '',
            special_03: '',
            special_04: '',
            special_05: ''
          })
        }
        this.data = res[0]
      })
    } else {
      this.data.agent_id = this.user.id
    }
  },
  methods: {
    save () {
      this.loading = true
      if (!this.data.name) {
        this.$Message.error('未填写方案名称,无法保存')
        this.loading = false
        return
      }
      for (let i in this.data) {
        if (this.data[i] === null && i !== 'old_id' && i !== 'note') {
          this.$Message.error(`未填写相关价格(0-1000),无法保存`)
          this.loading = false
          return
        }
      }

      let data = JSON.parse(JSON.stringify(this.data))
      // data.note = JSON.stringify(data.note);
      this.saveCharge(data).then((res) => {
        if (res.status) {
          if (res.id) {
            this.data.id = res.id
          }
          this.loading = false
          this.$Message.success('操作成功')
          this.$router.back()
        } else {
          this.loading = false
          this.$Message.error(res.log)
        }
      })
    },
    chargeAccess () {
      return hasOneOf(['0'], this.access)
    },
    changeModalData () {
      this.data.special_01 = this.modalData.special_01
      this.data.special_02 = this.modalData.special_02
      this.data.special_03 = this.modalData.special_03
      this.data.special_04 = this.modalData.special_04
      this.data.special_05 = this.modalData.special_05
      this.data.note = JSON.stringify(this.modalData.note)
      this.showModal = false
    },
    changeShowModalData () {
      this.modalData.special_01 = this.data.special_01
      this.modalData.special_02 = this.data.special_02
      this.modalData.special_03 = this.data.special_03
      this.modalData.special_04 = this.data.special_04
      this.modalData.special_05 = this.data.special_05
      this.modalData.note = JSON.parse(this.data.note)
      this.showModal = true
    },
    cancelShowModalData () {
      this.modalData.special_01 = this.data.special_01
      this.modalData.special_02 = this.data.special_02
      this.modalData.special_03 = this.data.special_03
      this.modalData.special_04 = this.data.special_04
      this.modalData.special_05 = this.data.special_05
      this.modalData.note = JSON.parse(this.data.note)
      this.showModal = false
    },
    ...mapActions(['getAgentList', 'saveCharge', 'infoCharge'])
  },
  computed: mapGetters({
    user: 'agent',
    access: 'access'
  })
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
